import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Link para o Tem em Casa (Smart Compras) levando QUEM esta logado no ELO: a tela de la
// le ?operador=, grava como operador e tira da URL (Adnéia, 23/09/2026). Nao e login —
// e so o nome que vai para a auditoria de cada clique.
export function comOperador(url, nome) {
  if (!url || !nome) return url;
  const sep = url.includes('?') ? '&' : '?';
  return `${url}${sep}operador=${encodeURIComponent(nome)}`;
}
